import { FC } from 'react';

export const ProgressBar: FC<{ progress: string | number }> = ({ progress }) => {
  return (
    <div className="mb-6 h-2.5 w-full overflow-hidden rounded-xl bg-[#303335]">
      <div
        className="h-full rounded-xl transition-all duration-300"
        style={{
          width: `${progress}%`,
          background: 'white',
        }}
      ></div>
    </div>
  );
};
